<p>Special Links Page</p>
<div class="container row flexbox-left" style="text-align:center; padding-left: 96px">
    <a (click)="navigateTo('special instructions')"
      class="col-md-1 sm-link sm-link_padding-all sm-link1 styled-links"
      style="white-space:nowrap; display: inline-block; width: 300px; cursor: pointer;">
      <h4 class="sm-link__label"><b>Special Instructions</b></h4>
    </a>

    <div class="divider"></div>

    <a  (click)="navigateTo('prehold')"
      class="sm-link sm-link_padding-all sm-link1 styled-links col-md-1"
      style="white-space:nowrap; display: inline-block; width: 225px; cursor: pointer;">
      <h4 class="sm-link__label"><b>PreHold</b></h4>
    </a>

    <div class="divider"></div>

    <!-- TODO: REPLACE PREHOLD PERMISSION WITH OWN PERMISSION -->
    <a (click)="navigateTo('delayed mail')"
       class="sm-link sm-link_padding-all sm-link1 styled-links col-md-1"
      style="white-space:nowrap; display: inline-block; width: 225px; cursor: pointer;">
      <h4 class="sm-link__label"><b>Delayed Mail</b></h4>
    </a>

    <!-- <div class="divider"></div> -->

    <a 
      (click)="navigateTo('production setup')"
      class="sm-link sm-link_padding-all sm-link1 styled-links col-md-1"
      style="white-space:nowrap; display: inline-block; width: 225px; cursor: pointer;">
      <h4 class="sm-link__label"><b>Production Setup</b></h4>
    </a>

    <div class="divider"></div>

    <a (click)="navigateTo('plan template')"
       class="sm-link sm-link_padding-all sm-link1 styled-links col-md-1"
      style="white-space:nowrap; display: inline-block; width: 225px; cursor: pointer">
      <h4 class="sm-link__label"><b>Plan Template</b></h4>
    </a>

    <div class="divider"></div>

  </div>

  <!-- row 2 -->
  <div class="container row flexbox-left" style="text-align:center; padding-left: 96px;">
    <a  (click)="navigateTo('production method')"
       class="sm-link sm-link_padding-all sm-link1 styled-links col-md-1"
      style="white-space:nowrap; display: inline-block; width: 300px; cursor: pointer;">
      <h4 class="sm-link__label"><b>Production Method Group</b></h4>
    </a>

    <div class="divider"></div>

    <a (click)="navigateTo('package template')"
       class="sm-link sm-link_padding-all sm-link1 styled-links col-md-1"
      style="white-space:nowrap; display: inline-block; width: 225px; cursor: pointer">
      <h4 class="sm-link__label"><b>Package Template</b></h4>
    </a>

    <!-- <div class="divider"></div> -->

    <a (click)="navigateTo('corp setup')"
       class="sm-link sm-link_padding-all sm-link1 styled-links col-md-1"
      style="white-space:nowrap; display: inline-block; width: 225px; cursor: pointer">
      <h4 class="sm-link__label"><b>Corp Setup</b></h4>
    </a>

    <div class="divider"></div>

    <a (click)="navigateTo('roleAdmin')"
          class="col-md-1 sm-link sm-link_padding-all sm-link1 styled-links"
          style="white-space:nowrap; display: inline-block; width: 250px; cursor: pointer;">
          <h4 class="sm-link__label"><b>Role Admin</b></h4>
        </a>

  </div>
